{
  "newsCard" : {
    "sticky": "Angepinnt"
  }
}